import React from 'react'
import Loading from '../../pages/Loading'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getPersonalDetails, getPreferredCourse, getCoursesSummary, getCourses } from '../../../services/vu'
import Error from '../../pages/errors/Error'
import { getCampusLocations, getCohortTypes } from '../../../services/reservoir'
import { receivePersonalDetails } from '../../../actions/personalDetails'

const mapStateToProps = ({ currentUser }) => {
  return {
    userRole: currentUser.data['role']
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setPersonalDetails: personalDetails => {
      dispatch(receivePersonalDetails(personalDetails))
    }
  }
}

class ParallelLoad extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: !(this.props.userRole === 'EDITOR' || this.props.userRole === 'REVIEWER'),
      failedToRetrievePersonalDetails: false,
      failedToRetrieveCourses: false
    }
  }

  componentDidMount() {
    if (this.state.loading) {
      //Promise.all([getPersonalDetails(), getCohortTypes(), getPreferredCourse(), getCampusLocations(), getCoursesSummary()])
      Promise.all([getPersonalDetails(), getCohortTypes(), getPreferredCourse(), getCampusLocations(), getCourses()])
        .then(([personalDetails, cohortTypes, preferredCourse, locations, summary]) => {
          this.props.setPersonalDetails(personalDetails)
          this.setState({
            loading: false
          })
        })
        .catch(error => {
          this.setState({
            loading: false,
            failedToRetrievePersonalDetails: error.response.config.url === '/api/student/personalData',
            failedToRetrieveCourses: error.response.config.url === '/api/student/courses',
            failedToRetrieveCoursesSummary: error.response.config.url === '/api/courses/summary'
          })
        })
    }
  }

  render() {
    if (this.state.failedToRetrievePersonalDetails) {
      return (
        <Error
          className="page__error--maintenance"
          title={'Failed to retrieve personal details'}
          longDescription={'The application has been unable to retrieve personal details.<BR >Please close the browser and try again.'}
          hideContactInfo={false}
        />
      )
    }

    if (this.state.failedToRetrieveCourses || this.state.failedToRetrieveCoursesSummary) {
      return (
        <Error
          className="page__error--maintenance"
          title={'Failed to retrieve courses'}
          longDescription={'The application has been unable to retrieve your courses.<BR >Please close the browser and try again.'}
          hideContactInfo={false}
        />
      )
    }

    if (this.state.loading) {
      return <Loading />
    }

    return this.props.children
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ParallelLoad)
)
